/**
 * useGuestMode
 *
 * Single source of truth for whether the current session is an unclaimed
 * guest preview account.
 *
 * State is stored in localStorage so it survives page refreshes:
 *   localStorage.isGuest          = 'true'
 *   localStorage.guestPackId      = <packId>
 *   localStorage.guestSpaceId     = <spaceId>
 *
 * The seed chat message is written once (by GuestStart) into
 *   sessionStorage.guestSeedChatMessage
 * and consumed by SpaceChat on mount.
 */

export const GUEST_FLAG_KEY = 'isGuest';
export const GUEST_PACK_ID_KEY = 'guestPackId';
export const GUEST_SPACE_ID_KEY = 'guestSpaceId';
export const GUEST_SEED_CHAT_KEY = 'guestSeedChatMessage';

export function isGuestSession(): boolean {
  return localStorage.getItem(GUEST_FLAG_KEY) === 'true';
}

export function getGuestPackId(): string | null {
  return localStorage.getItem(GUEST_PACK_ID_KEY);
}

export function getGuestSpaceId(): string | null {
  return localStorage.getItem(GUEST_SPACE_ID_KEY);
}

export function setGuestSession(params: {
  packId: string;
  spaceId: string;
  seedChatMessage?: string | null;
}): void {
  localStorage.setItem(GUEST_FLAG_KEY, 'true');
  localStorage.setItem(GUEST_PACK_ID_KEY, params.packId);
  localStorage.setItem(GUEST_SPACE_ID_KEY, params.spaceId);
  if (params.seedChatMessage) {
    sessionStorage.setItem(GUEST_SEED_CHAT_KEY, params.seedChatMessage);
  }
}

export function clearGuestSession(): void {
  localStorage.removeItem(GUEST_FLAG_KEY);
  localStorage.removeItem(GUEST_PACK_ID_KEY);
  localStorage.removeItem(GUEST_SPACE_ID_KEY);
  sessionStorage.removeItem(GUEST_SEED_CHAT_KEY);
}
